module.exports = __webpack_public_path__ + "img/scan_pay.a747d694.png";